/** Gift URL placeholder in user-facing templates. Supports legacy `[gift_link]` for existing saved content. */
export function hasGiftLinkPlaceholder(value: string | undefined | null): boolean {
  if (!value) return false;
  const v = value.toLowerCase();
  return v.includes("{gift_link}") || v.includes("[gift_link]");
}

export function replaceGiftLinkPlaceholders(value: string, replacement: string): string {
  return value.replace(/\{gift_link\}|\[gift_link\]/gi, replacement);
}

export function stripGiftLinkPlaceholders(value: string): string {
  return value.replace(/\{gift_link\}|\[gift_link\]/g, "");
}
